import { useContext } from 'react';
import JsonnetContext from '../contexts/Jsonnet.context';
export function usePlatformConfig() {
    const jsonnetConfiguration = useContext(JsonnetContext);
    if (!jsonnetConfiguration) {
        throw new Error('Missing config from context.');
    }
    return { platformConfig: jsonnetConfiguration };
}
//# sourceMappingURL=usePlatformConfig.js.map